import { render, staticRenderFns } from "./editPage.vue?vue&type=template&id=8ff696d0&scoped=true"
import script from "./editPage.vue?vue&type=script&lang=js"
export * from "./editPage.vue?vue&type=script&lang=js"
import style0 from "./editPage.vue?vue&type=style&index=0&id=8ff696d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff696d0",
  null
  
)

export default component.exports